<div class="detail-wrap">

  <div class="detail-list-item-group" *ngIf="homonymDetail && homonymDetail.listWord">

    <div class="detail-list-item-box" *ngFor="let word of homonymDetail.listWord; let idx = index">
      <div class="keyword-item-box on">

        <div class="keyword-top-box">

<!--
          <div class="keyword-rate-box" *ngIf="word.level > 0">
            <i class="ic ic-rate" *ngFor="let i of Array(word.level).fill(1)"></i>
          </div>
-->

          <app-word-disp [word]="word"
                         [select]="true"></app-word-disp>

          <app-word-play-btn [word]="word"></app-word-play-btn>

          <app-word-record-btn [word]="word"></app-word-record-btn>

          <div class="help-btn-box" *ngIf="idx === 0">
            <button type="button"
                    class="help-btn"
                    (click)="onOpenHelp()">도움말</button>
          </div>

        </div>


        <div class="fixed-menu" *ngIf="idx === 0">
          <div class="menu-wrap">
            <a class="detail-menu-btn close-btn" (click)="onClose()"></a>
          </div>
        </div>
      </div>

      <div class="detail-head-box">

        <div class="layout-box">

          <div class="key-box">
            <div class="key-txt"
                 *ngFor="let poomsa of word.partOfSpeech">{{ GetPoomsaTxt(poomsa) }}</div>
          </div>

          <div class="item-box">

            <div class="item-list">
              <div class="word-item"
                   *ngFor="let hun of word.hanjaHun">
                <div class="item-txt">
                  {{ hunBody(hun) }}
                  <div class="char">{{ hunChar(hun) }}</div>
                </div>
              </div>
            </div>


          </div>

        </div>

        <!-- div class="fixed-menu" *ngIf="idx === 0">
          <div class="menu-wrap">
            <a class="detail-menu-btn close-btn" (click)="onClose()"></a>
          </div>
        </div -->

        <div class="detail-menu2">
          <div class="menu-wrap">
            <a class="detail-menu-btn bookmark-btn {{ getBmCss(word) }}"
               (click)="ToggleBookmark($event, word)"></a>
          </div>
        </div>



      </div>

      <div class="detail-body">

        <div class="detail-item-list">

          <ng-container *ngFor="let mean of word.meaning3; let midx = index">
            <div class="detail-item-box"
                 *ngIf="mean">

            <div class="word-list">
              <div class="word-box">

                <div class="subject">뜻{{ midx === 0 ?  '' : midx }}</div>
                <div class="con">
                  <app-link-content class="txt-box"
                                    [content]="mean | resize"></app-link-content>
                  <div class="other-list">
                    <div class="other-box {{ word.HaveExVoiceNth(midx) ? 'sound' : '' }}" *ngIf="word.GetExample3Nth(midx)">
                      <!-- app-word-ex-play-btn [word]="word"
                                            [exNum]="midx">
                      </app-word-ex-play-btn -->
                      <div class="other-type-box">
                        <div class="other-type">활</div>
                      </div>

                      <div class="other-txt-box">
                        <div *ngFor="let ex of word.GetExample3Nth(midx); let exidx = index"
                             class="other-txt-item" >
                          <app-link-content class="other-txt"
                                            [content]="ex | rmSlash | resize"></app-link-content>
                          <div class="record-box">
                            <app-word-ex-play-btn *ngIf="word.GetExVoice(midx, exidx)"
                                                  [word]="word"
                                                  [exNum]="word.GetExVoiceIdx(midx, exidx)">
                            </app-word-ex-play-btn>
                            <app-word-example-btn *ngIf="word.GetExampleSjNth2(midx, exidx)?.seungjo"
                                                  [word]="word"
                                                  [exampleSJ]="word.GetExampleSjNth2(midx, exidx)">
                            </app-word-example-btn>
                          </div>
                        </div>
                      </div>

                    </div>

                  </div>

                </div>
              </div>

            </div>

          </div>
          </ng-container>

          <div class="detail-item-box" *ngIf="word.synonym && word.synonym.length > 0">
            <div class="word-list">
              <div class="word-box">
                <div class="subject">유의어</div>
                <div class="con">
                  <app-link-content *ngFor="let synonym of word.synonym"
                                    class="txt-box gray"
                                    [content]="synonym | resize"></app-link-content>
                </div>
              </div>
            </div>
          </div>

          <div class="detail-item-box" *ngIf="word.derivative && word.derivative.length > 0">
            <div class="word-list">
              <div class="word-box">
                <div class="subject">관련어</div>
                <div class="con">
                  <app-link-content *ngFor="let derivative of word.derivative"
                                    class="txt-box gray"
                                    [content]="derivative | resize"></app-link-content>
                </div>
              </div>
            </div>
          </div>

        </div>

      </div>
    </div>
  </div>


</div>
